import React from 'react';
import {
  FontDownload
} from "@mui/icons-material";
import Grid from '@mui/material/Grid2';

import { 
  CharacterItem,
  Item,
  // IMagicItem, 
  PseudoItem,
  Armor,
  Weapon,
  // IMagicItemColor,
  EquipmentPack,
  // MagicItem,
  // WeaponKeyword,
  CharacterArmor,
  Character,
  MagicItemKeyword,
  CharacterWeapon,
  WEAPON_KEYWORDS
} from "@dndModels";
import { RARITY_NUM_TO_COLOR_MAP } from "@dndModels/Constants";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";

interface Props {
  item: Item | MagicItemKeyword | PseudoItem | CharacterItem | EquipmentPack;
  character?: Character;
  log_it?: boolean;
}

// const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function ViewItem({
  item,
  character,
  log_it = false
}: Props) {

  const get_base_item_detail = (base_item: Item) => {
    let detail = "";
    if (base_item.item_type === "Armor" && 
      base_item instanceof Armor && base_item.armor_type) {
      detail = base_item.armor_type_name;
      const ac = base_item.base_armor_class;
      if (base_item.armor_type.name === "Shield") {
        detail += `: AC + ${ac}`;
      } else if (character) {
        if (base_item.armor_type.dex_bonus_max === null) { // Light = null
          const plus = Math.max(character.mind.current_ability_scores.DEX, 0);
          const total_ac = ac + plus;
          detail += `: Base AC = ${total_ac} (${ac} + ${plus})`;
        } else if (base_item.armor_type.dex_bonus_max === true) { // Medium = true
          const plus = Math.min(2, Math.max(0, character.mind.current_ability_scores.DEX));
          const total_ac = ac + plus;
          detail += `: Base AC = ${total_ac} (${ac} + ${plus})`;
        } else { // Heavy = false
          detail += `: Base AC = ${ac}`;
        }
      } else {
        if (base_item.armor_type.dex_bonus_max === null) { // Light = null
          detail += `: Base AC = ${ac} + DEX`;
        } else if (base_item.armor_type.dex_bonus_max === true) { // Medium = true
          detail += `: Base AC = ${ac} + DEX (Max 2)`;
        } else { // Heavy = false
          detail += `: Base AC = ${ac}`;
        }
      }
    } else if (base_item.item_type === "Weapon" && base_item instanceof Weapon) {
      const weapon_keyword_ids = character && item instanceof CharacterWeapon ? char_util.getWeaponKeywordIds(character, item) : base_item.weapon_keyword_ids;
      const show_monk = character && character.spirit.classes.filter(o => o.name.includes("Monk")).length > 0 ? true : false;
      detail = WEAPON_KEYWORDS.filter(o => 
        weapon_keyword_ids.includes(o._id) &&
        (o.display_in_equipment || (o.name === "Monk" && show_monk))
      ).map(o => o.name).join(", ");
      const wmp = data_util.weapon_mastery_properties.find(o => o._id === base_item.weapon_mastery_property_id);
      if (wmp) {
        detail += `\n${wmp.name}`;
      }
    }
    return detail;
  }

  let detail = "";
  let detail2 = "";
  let show_attunement_icon = false;
  let color = "inherit";
  if (log_it) {
    debugger;
  }
  if (item instanceof CharacterItem) {
    color = RARITY_NUM_TO_COLOR_MAP[item.rarity];
    show_attunement_icon = item.attunement;
    if (item.base_item) {
      detail = get_base_item_detail(item.base_item);
      if (item.name !== item.base_item.name) {
        if (detail !== "") {
          detail += " - ";
        }
        detail += item.base_item.name;
      }
    }
    if (item instanceof CharacterArmor && item.armor_type && character) {
      let ac = item.armor_class;
      if (item.armor_type.dex_bonus_max === null) { // Light = null
        ac += Math.max(character.mind.current_ability_scores.DEX, 0);
      } else if (item.armor_type.dex_bonus_max === true) { // Medium = true
        ac += Math.min(2, Math.max(0, character.mind.current_ability_scores.DEX));
      } // Heavy = false
      detail2 += `: Base AC = ${ac}`;
    }
  // } else if ((item instanceof Item && item.magical) || item instanceof MagicItem) {
  //   const magic_item = item as IMagicItem;
  //   color = IMagicItemColor(magic_item);
  //   show_attunement_icon = magic_item.attunement;
  //   if (magic_item.base_item) {
  //     detail = get_base_item_detail(magic_item.base_item);
  //     detail += ` - ${ magic_item.base_item.name }`;
  //   }
  } else if (item instanceof Item) {
    detail = get_base_item_detail(item);
    color = RARITY_NUM_TO_COLOR_MAP[item.min_rarity];
    show_attunement_icon = item.attunement;
  } else if (item instanceof MagicItemKeyword) {
    color = RARITY_NUM_TO_COLOR_MAP[item.min_rarity];
    show_attunement_icon = item.attunement;
  } else if (item instanceof PseudoItem) {
    color = RARITY_NUM_TO_COLOR_MAP[item.rarity];
    show_attunement_icon = item.attunement;
    if (item.the_base_item) {
      detail = get_base_item_detail(item.the_base_item);
      detail += ` - ${ item.the_base_item.name }`;
    }
  } 
  return (
    <Grid container spacing={0} direction="column" style={{ fontSize: "10px" }}>
      <Grid>
        <span style={{ color, fontWeight: "bold" }}>{ item.name }{ detail2 }</span> { show_attunement_icon && <FontDownload fontSize="inherit" /> }
      </Grid>
      <Grid
        style={{ 
          lineHeight: "1.1",
        }}
        className="small_label gray">
        <DisplayStringWithReplacements display_string={ detail } />
      </Grid>
    </Grid>
  );
}
